export default [
    {
        title: '供应商管理',
        path: '/supplier',
        name: 'supplier',
        meta: {
            key: 'supplier'
        },
        permission: 'supplier',
        menu: true, // 不在主菜单显示，仅保留路由功能（通过"主数据管理"访问）
        component: () => import('@/views/supplier/list')
    }
];
